export const logoIndustriesExampleData = [
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo",
  "Something Logo"
];
